// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03c36a13","453":"8d32c05b","455":"2e5c3aba"}[chunkId] + ".chunk.js";
};